import React, { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";

import TextInput from "../../inputs/TextInput";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";
import { VALIDATOR_MINLENGTH } from "../../../utils/finalForm/validators/VALIDATOR_MINLENGTH";

const RffTextareaField = ({
  name,
  label,
  subLabel,
  required = false,
  /** New prop: if passed, field is required and must have at least this many chars */
  minCharCount,
  suppressGrid,
  placeholder = "Enter value",
  size,
  disabled,
  helperText,
  onBlur,
  rows = 6,
  minHeight,
}) => {
  // Build an array of validators whenever `required` or `minCharCount` changes
  const validate = useMemo(() => {
    const validators = [];

    // Make it required if either `required` is true or `minCharCount` is set
    if (required || minCharCount) {
      validators.push(VALIDATOR_REQUIRE);
    }
    // If you passed minCharCount, also enforce minimum length
    if (minCharCount) {
      validators.push(VALIDATOR_MINLENGTH(minCharCount));
    }

    // If no validators, return undefined so Field skips validation
    if (validators.length === 0) {
      return undefined;
    }

    // Compose into a single validate fn
    return (value) => {
      for (let fn of validators) {
        const error = fn(value);
        if (error) {
          return error;
        }
      }
    };
  }, [required, minCharCount]);

  return (
    <RffInputWrapper
      label={label}
      subLabel={subLabel}
      suppressGrid={suppressGrid}
      size={size}
      /** Show a required indicator if it's logically required */
      required={required || Boolean(minCharCount)}
      helperText={helperText}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => (
          <TextInput
            {...input}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            multiline
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            minRows={1}
            maxRows={rows}
            size="medium"
            InputProps={{
              style: {
                ...(minHeight ? { minHeight } : {}),
                alignItems: "flex-start",
              },
              inputProps: {
                style: { verticalAlign: "top" },
              },
            }}
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffTextareaField;
